import {Directive, HostListener, Inject, Input, PLATFORM_ID} from '@angular/core';
import {FormDataTrackingService} from '@app/services/analytics/form-data-tracking.service';
import {isPlatformBrowser} from '@angular/common';
import {CampaignTrackingService} from '@app/services/campaign-tracking.service';
import {EventService, Product} from '@spartacus/core';
import {EddlFormSubmitEvent} from '@app/services/analytics/EDDL/events/eddl-form-submit-event';
import {EddlFormErrorEvent} from '@app/services/analytics/EDDL/events/eddl-form-error-event';

export interface SubmitFormButtonOptions {
  name: string;
  useCustomTrigger?: boolean;
  transactionId?: string;
  product?: Product;
}

@Directive({
  selector: '[dcpSubmitFormButton]'
})
export class SubmitFormButtonDirective {

  @Input() dcpSubmitFormButton: SubmitFormButtonOptions = {
    name: '',
    useCustomTrigger: false,
    transactionId: '',
    product: undefined,
  };

  constructor(
    @Inject(PLATFORM_ID) public platformId: object,
    private formDataTrackingService: FormDataTrackingService,
    private campaignTrackingService: CampaignTrackingService,
    private eventService: EventService
  ) {
  }

  @HostListener('click') onMouseEnter() {
    if (!this.dcpSubmitFormButton.useCustomTrigger) {
      this.triggerSubmitTrackingCall();
    }
  }

  public triggerSubmitTrackingCall(transactionId?: string, country?: string) {
    if (isPlatformBrowser(this.platformId)) {
      this.formDataTrackingService.trackFormSubmit(
        transactionId || this.dcpSubmitFormButton.transactionId,
        this.dcpSubmitFormButton.name,
        country,
        this.campaignTrackingService.getCampaignData(),
        this.dcpSubmitFormButton.product,
      );
    }
  }

  public triggerEddlSubmitFormEvent(transactionId?: string, country?: string) {
    if (isPlatformBrowser(this.platformId)) {
      const event = new EddlFormSubmitEvent();
      event.transactionId = transactionId || this.dcpSubmitFormButton.transactionId;
      event.name = this.dcpSubmitFormButton.name;
      event.country = country;
      setTimeout(() => this.eventService.dispatch(event));
    }
  }

  public triggerErrorTrackingCall(errorMessage: string) {
    if (isPlatformBrowser(this.platformId)) {
      this.formDataTrackingService.trackFormError(errorMessage);
    }
  }

  public triggerEddlFormErrorEvent(errorMessage: string) {
    if (isPlatformBrowser(this.platformId)) {
      const event = new EddlFormErrorEvent();
      event.name = this.dcpSubmitFormButton.name;
      event.errorDescription = errorMessage;
      setTimeout(() => this.eventService.dispatch(event));
    }
  }
}
